import type { LegacyCognito } from './legacy-cognito-types';

export const getLegacyCognito = () =>
	(globalThis as typeof globalThis & { Cognito: LegacyCognito }).Cognito;
